import type { ReactNode } from 'react'
import { Button, DialogContentText } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ActionDialog from './ActionDialog'

interface ConfirmActionDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: ReactNode
  message: ReactNode
  confirmLabel: ReactNode
}

const ConfirmActionDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
}: ConfirmActionDialogProps) => {
  const { t } = useTranslation()

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      title={title}
      actions={
        <>
          <Button type="button" variant="outlined" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button type="button" variant="contained" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <DialogContentText>{message}</DialogContentText>
    </ActionDialog>
  )
}

export default ConfirmActionDialog
